import React, { useState } from 'react';

import { Box, Icon, Pressable, Text } from '@rbilabs/universal-components';

import { A11yWrapper } from 'components/a11y-wrapper';
import { t } from 'state/intl/translations';
import { theme as configureTheme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import theme from './theme';

const PhoneNumberInformation = Text.withConfig({
  variant: 'copyTwo',
  color: theme.phoneNumberInformationColor,
  textAlign: 'center',
  fontSize: 'xs',
  marginTop: '$3',
});

const PhoneNumberToggle = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

const PhoneAddressInformationToggle = () => {
  const [visible, setVisible] = useState(false);

  return (
    <Box marginBottom="$3">
      <PhoneNumberToggle onPress={() => setVisible(!visible)}>
        <Text variant="copyTwo" fontWeight="bold">
          {t('whyDoYouNeedMyPhoneNumber')}
        </Text>
        <Icon
          variant={!visible ? 'select' : 'collapse'}
          color={configureTheme.token('icon-default')}
          width="24px"
          {...hiddenAccessibilityPlatformProps}
        />
      </PhoneNumberToggle>
      {visible && (
        <A11yWrapper>
          <PhoneNumberInformation testID="phoneNumberDisclaimer">
            {t('deliveryPhoneDisclosure')}
          </PhoneNumberInformation>
        </A11yWrapper>
      )}
    </Box>
  );
};

export default PhoneAddressInformationToggle;
